import { toast } from "sonner";
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { MessageCircle } from "lucide-react";
import { Logger } from "@/lib/logger/Logger";

const backgroundColors = {
	error: "#ef4444",
	success: "#22c55e",
	warning: "#fb923c",
	info: "#3F96FD",
	message: "#9333ea",
};

const icons = {
	error: <ErrorIcon />,
	success: <CheckCircleIcon />,
	warning: <WarningIcon />,
	info: <InfoIcon />,
	message: <MessageCircle className="w-5 h-5" />,
};

export const showNotification = ({
	message,
	type,
	duration,
	action,
	description,
	log,
}: {
	message: string;
	type: "error" | "success" | "info" | "warning" | "message";
	duration?: number;
	action?: {
		label: string;
		onClick: () => void;
	};
	description?: string;
	log?: {
		identifier: string;
	};
}) => {
	if (log) {
		Logger.error(message, {
			identifier: log.identifier,
		});
	}
	toast(message, {
		icon: icons[type],
		style: {
			backgroundColor: backgroundColors[type],
			color: type !== "success" ? "white" : "black",
		},
		// Using className because data-testid isn't available on the component
		className: `toast-${type}`,
		...(duration && {
			duration,
		}),

		...(action && {
			action,
		}),
		...(description && {
			description,
		}),
	});
};

export { showMessageNotification } from "../../components/notifications/message-notification.component";
